import R from "./helpers/bind.js";
const { toString: T } = Object.prototype, { getPrototypeOf: A } = Object, { iterator: g, toStringTag: S } = Symbol, F = /* @__PURE__ */ ((e) => (t) => {
  const r = T.call(t);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), f = (e) => (e = e.toLowerCase(), (t) => F(t) === e), O = (e) => (t) => typeof t === e, { isArray: a } = Array, p = O("undefined");
function d(e) {
  return e !== null && !p(e) && e.constructor !== null && !p(e.constructor) && i(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const B = f("ArrayBuffer");
function M(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && B(e.buffer), t;
}
const k = O("string"), i = O("function"), E = O("number"), y = (e) => e !== null && typeof e == "object", N = (e) => e === !0 || e === !1, w = (e) => {
  if (F(e) !== "object")
    return !1;
  const t = A(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(S in e) && !(g in e);
}, I = (e) => {
  if (!y(e) || d(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, U = f("Date"), V = f("File"), _ = f("Blob"), q = f("FileList"), H = (e) => y(e) && i(e.pipe), z = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || i(e.append) && ((t = F(e)) === "formdata" || // detect form-data instance
  t === "object" && i(e.toString) && e.toString() === "[object FormData]"));
}, J = f("URLSearchParams"), [K, $, W, G] = ["ReadableStream", "Request", "Response", "Headers"].map(f), Q = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function m(e, t, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let n, s;
  if (typeof e != "object" && (e = [e]), a(e))
    for (n = 0, s = e.length; n < s; n++)
      t.call(null, e[n], n, e);
  else {
    if (d(e))
      return;
    const o = r ? Object.getOwnPropertyNames(e) : Object.keys(e), c = o.length;
    let l;
    for (n = 0; n < c; n++)
      l = o[n], t.call(null, e[l], l, e);
  }
}
function P(e, t) {
  if (d(e))
    return null;
  t = t.toLowerCase();
  const r = Object.keys(e);
  let n = r.length, s;
  for (; n-- > 0; )
    if (s = r[n], t === s.toLowerCase())
      return s;
  return null;
}
const u = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, L = (e) => !p(e) && e !== u;
function h() {
  const { caseless: e } = L(this) && this || {}, t = {}, r = (n, s) => {
    const o = e && P(t, s) || s;
    w(t[o]) && w(n) ? t[o] = h(t[o], n) : w(n) ? t[o] = h({}, n) : a(n) ? t[o] = n.slice() : t[o] = n;
  };
  for (let n = 0, s = arguments.length; n < s; n++)
    arguments[n] && m(arguments[n], r);
  return t;
}
const X = (e, t, r, { allOwnKeys: n } = {}) => (m(t, (s, o) => {
  r && i(s) ? e[o] = R(s, r) : e[o] = s;
}, { allOwnKeys: n }), e), Y = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), Z = (e, t, r, n) => {
  e.prototype = Object.create(t.prototype, n), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), r && Object.assign(e.prototype, r);
}, j = (e, t, r, n) => {
  let s, o, c;
  const l = {};
  if (t = t || {}, e == null) return t;
  do {
    for (s = Object.getOwnPropertyNames(e), o = s.length; o-- > 0; )
      c = s[o], (!n || n(c, e, t)) && !l[c] && (t[c] = e[c], l[c] = !0);
    e = r !== !1 && A(e);
  } while (e && (!r || r(e, t)) && e !== Object.prototype);
  return t;
}, v = (e, t, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= t.length;
  const n = e.indexOf(t, r);
  return n !== -1 && n === r;
}, ee = (e) => {
  if (!e) return null;
  if (a(e)) return e;
  let t = e.length;
  if (!E(t)) return null;
  const r = new Array(t);
  for (; t-- > 0; )
    r[t] = e[t];
  return r;
}, te = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && A(Uint8Array)), ne = (e, t) => {
  const n = (e && e[g]).call(e);
  let s;
  for (; (s = n.next()) && !s.done; ) {
    const o = s.value;
    t.call(e, o[0], o[1]);
  }
}, re = (e, t) => {
  let r;
  const n = [];
  for (; (r = e.exec(t)) !== null; )
    n.push(r);
  return n;
}, se = f("HTMLFormElement"), oe = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(r, n, s) {
    return n.toUpperCase() + s;
  }
), x = (({ hasOwnProperty: e }) => (t, r) => e.call(t, r))(Object.prototype), ie = f("RegExp"), C = (e, t) => {
  const r = Object.getOwnPropertyDescriptors(e), n = {};
  m(r, (s, o) => {
    let c;
    (c = t(s, o, e)) !== !1 && (n[o] = c || s);
  }), Object.defineProperties(e, n);
}, ce = (e) => {
  C(e, (t, r) => {
    if (i(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const n = e[r];
    if (i(n)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, fe = (e, t) => {
  const r = {}, n = (s) => {
    s.forEach((o) => {
      r[o] = !0;
    });
  };
  return a(e) ? n(e) : n(String(e).split(t)), r;
}, le = () => {
}, ue = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function ae(e) {
  return !!(e && i(e.append) && e[S] === "FormData" && e[g]);
}
const pe = (e) => {
  const t = new Array(10), r = (n, s) => {
    if (y(n)) {
      if (t.indexOf(n) >= 0)
        return;
      if (d(n))
        return n;
      if (!("toJSON" in n)) {
        t[s] = n;
        const o = a(n) ? [] : {};
        return m(n, (c, l) => {
          const b = r(c, s + 1);
          !p(b) && (o[l] = b);
        }), t[s] = void 0, o;
      }
    }
    return n;
  };
  return r(e, 0);
}, de = f("AsyncFunction"), ye = (e) => e && (y(e) || i(e)) && i(e.then) && i(e.catch), D = ((e, t) => e ? setImmediate : t ? ((r, n) => (u.addEventListener("message", ({ source: s, data: o }) => {
  s === u && o === r && n.length && n.shift()();
}, !1), (s) => {
  n.push(s), u.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(
  typeof setImmediate == "function",
  i(u.postMessage)
), me = typeof queueMicrotask < "u" ? queueMicrotask.bind(u) : typeof process < "u" && process.nextTick || D, we = (e) => e != null && i(e[g]), Fe = {
  isArray: a,
  isArrayBuffer: B,
  isBuffer: d,
  isFormData: z,
  isArrayBufferView: M,
  isString: k,
  isNumber: E,
  isBoolean: N,
  isObject: y,
  isPlainObject: w,
  isEmptyObject: I,
  isReadableStream: K,
  isRequest: $,
  isResponse: W,
  isHeaders: G,
  isUndefined: p,
  isDate: U,
  isFile: V,
  isBlob: _,
  isRegExp: ie,
  isFunction: i,
  isStream: H,
  isURLSearchParams: J,
  isTypedArray: te,
  isFileList: q,
  forEach: m,
  merge: h,
  extend: X,
  trim: Q,
  stripBOM: Y,
  inherits: Z,
  toFlatObject: j,
  kindOf: F,
  kindOfTest: f,
  endsWith: v,
  toArray: ee,
  forEachEntry: ne,
  matchAll: re,
  isHTMLForm: se,
  hasOwnProperty: x,
  hasOwnProp: x,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: C,
  freezeMethods: ce,
  toObjectSet: fe,
  toCamelCase: oe,
  noop: le,
  toFiniteNumber: ue,
  findKey: P,
  global: u,
  isContextDefined: L,
  isSpecCompliantForm: ae,
  toJSONObject: pe,
  isAsyncFn: de,
  isThenable: ye,
  setImmediate: D,
  asap: me,
  isIterable: we
};
export {
  Fe as default
};
